import React from "react";
import {connect} from 'react-redux'

// @material-ui/icons
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

// @material-ui/core components
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import LinearProgress from '@material-ui/core/LinearProgress';
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

//ibTrees
import {ibTreeSave, ibTreesFetch, ibTreeFetch} from 'actions/ibTrees'

import {danger, success} from 'actions/notification'
//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";
const PROFILES_TYPES={}

class Form extends React.Component {
  state = {
    form: {
      ibTreeId: 0,
      commissionRebate: 0,
      crPerType: Object.keys(PROFILES_TYPES)[0],
      mrPerType: Object.keys(PROFILES_TYPES)[0],
      markupRebate: 0,
      spread: 0,
      name: ''
    }
  }
  componentDidMount() {
    //Fetch information if is edit form
    if (this.props.match.params.id) 
      this.props.fetch(this.props.match.params.id).then(e => this.setState({
        ...this.state,
        form: {
          ...e
        }
      }));

    }
  //Submit form
  submit(e) {
    if (e.preventDefault) 
      e.preventDefault();
    this
      .props
      .save(this.state.form)
      .then(e => {
        this
          .props
          .success(e.name + ' ' + (e.ibTreeId
            ? 'Edited'
            : 'Added') + '!', 4);
        this
          .props
          .history
          .goBack()
      })
      .catch(e => {
        this
          .props
          .danger(e + '', 4);
      })
  }
  //OnChange action for all inputs and selects
  change(event, name) {
    this.setState({
      ...this.state,
      form: {
        ...this.state.form,
        [name]: event.target.value
      }
    })
  }

  /* {
    name:string //Displayed label
    key:string //value of state
    required:boolean //required validation
    icon:node //icon of input
  }*/
  getInput(data) {
    return <CustomInput
      labelText={< span > {
      data.name
    }
    {
      (data.required
        ? 
        <small>(required)</small>
        : data.required)
    } </span>}
      id={data.key}
      formControlProps={{
      fullWidth: true
    }}
      inputProps={{
      onChange: event => this.change(event, data.key),
      required: data.required,
      value: this.state.form[data.key],
      type: data.type,
      endAdornment: (data.icon
        ? <InputAdornment position="end" className={this.props.classes.inputAdornment}>
            {data.icon}
          </InputAdornment>
        : '')
    }}/>
  }
  render() {
    const {classes, isFetching} = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={8}>
          <Card>
            <CardBody>

              {//Show progress onFetch
              (isFetching)
                ? <LinearProgress/>
                : <form onSubmit={this
                  .submit
                  .bind(this)}>
                  <GridContainer justify="center">
                    {/*Header Information*/}
                    <GridItem xs={12} sm={12}>
                      <h4 className={classes.infoText}>
                        Complete information
                      </h4>
                    </GridItem>
                    {/*Right 2 inputs*/}
                    <GridItem xs={12} sm={10}>
                      {/*Name input*/}
                      {this.getInput({
                        key: 'name', name: 'Name', icon: <RecordVoiceOverIcon className={this.props.classes.inputAdornmentIcon}/>,
                        type: 'text',
                        required: true
                      })}
                      {/*Email input*/}
                    </GridItem>
                    <GridItem xs={12} sm={10} md={10} lg={3}>
                      {this.getInput({key: 'commissionRebate', name: 'Commission Rebate ', type: 'number'})}
                    </GridItem>
                    <GridItem xs={12} sm={10} md={10} lg={3}>
                      {this.getInput({key: 'markupRebate', name: 'Markup Rebate', type: 'number'})}
                    </GridItem>
                    <GridItem xs={12} sm={10} md={10} lg={4}>
                      {this.getInput({key: 'spread', name: 'Spread', type: 'number'})}
                    </GridItem>
                    {/* Select crPerType */}
                    <GridItem xs={12} sm={10} md={10} lg={10}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel htmlFor="crPerType" className={classes.selectLabel} >
                        Select crPerType
                      </InputLabel>
                      <Select
                        value={this.state.form.crPerType}
                        MenuProps={{
                        className: classes.selectMenu
                      }}
                        classes={{
                        select: classes.select
                      }}
                        inputProps={{
                        onChange: event => this.change(event, "crPerType"),
                        id: "crPerType"
                      }}>
                        {Object
                          .keys(PROFILES_TYPES)
                          .map((e) => (
                            <MenuItem
                              key={e}
                              classes={{
                              root: classes.selectMenuItem
                            }}
                              value={e}>
                              {PROFILES_TYPES[e]}
                            </MenuItem>
                          ))}
                      </Select>

                    </FormControl>
                    </GridItem>
                   {/* Select mrPerType  */}
                   <GridItem xs={12} sm={10} md={10} lg={10}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel htmlFor="mrPerType" className={classes.selectLabel} >
                        Select mrPerType
                      </InputLabel>
                      <Select
                        value={this.state.form.mrPerType}
                        MenuProps={{
                        className: classes.selectMenu
                      }}
                        classes={{
                        select: classes.select
                      }}
                        inputProps={{
                        onChange: event => this.change(event, "mrPerType"),
                        id: "mrPerType"
                      }}>
                        {Object
                          .keys(PROFILES_TYPES)
                          .map((e) => (
                            <MenuItem
                              key={e}
                              classes={{
                              root: classes.selectMenuItem
                            }}
                              value={e}>
                              {PROFILES_TYPES[e]}
                            </MenuItem>
                          ))}
                      </Select>

                    </FormControl>
                    </GridItem>
                  
                  </GridContainer>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      <Button type="submit" className={classes.submit} color="rose">Submit</Button>
                    </GridItem>
                  </GridContainer>
                </form>
}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}
const mapStateToProps = (state, props) => ({isFetching: state.ibTrees.isFetching, ibTreeies: state.ibTrees.list})
const mapDispatchToProps = (dispatch) => ({
  fetch: (id) => dispatch(ibTreeFetch(id)),
  fetchAll: () => dispatch(ibTreesFetch()),
  save: (data) => dispatch(ibTreeSave(data)),
  danger: (text, sec) => dispatch(danger(text, sec)),
  success: (text, sec) => dispatch(success(text, sec))
})
export default withStyles({...styles,...selectStyles})(connect(mapStateToProps, mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./src/views/IbTree/Form.jsx